import React from 'react'
import { render } from 'react-dom'
import App from './components/App'
import { ErrorBoundary } from 'react-error-boundary'
import { BrowserRouter } from 'react-router-dom'
import 'semantic-ui-css/semantic.min.css'
import './assets/css/FairWork.Screen.css'
import './components/common/common.css'
import './assets/css/fwoforms.css'
import { ReactSVG } from 'react-svg'
import { EventType } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from './services/AuthenticationService'
import ErrorFallback from './components/common/ErrorFallback'
import IdleTimer from 'react-idle-timer'
import { PATHS } from './components/Routes'
import { IdleTime } from './models/Common'
import ProfileService from './services/ProfileService'
import axios from 'axios'

if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account
    msalInstance.setActiveAccount(account)

    const source = axios.CancelToken.source()
    ProfileService.recordLoginDate(source).catch(() => {
      /* no action on error */
    })
  }
})

const handleOnIdle = () => {
  msalInstance.logoutRedirect({
    postLogoutRedirectUri: PATHS.FWO,
  })
}

render(
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <IdleTimer timeout={1000 * 60 * IdleTime} onIdle={handleOnIdle} />
       
        <App />
        
      </MsalProvider>
    </BrowserRouter>
    <div style={{ display: 'none' }}>
      <ReactSVG src="/public/svg-icon.svg" />
    </div>
  </ErrorBoundary>,

  document.getElementById('root')
)
